import React, { useEffect, useRef, useState } from "react";
import userImage from "../../assets/images/folder.png";
import fileImage from "../../assets/images/file.png";
import more from "../../assets/images/more3.png";
import addIcon from "../../assets/images/add.png";
import renameIcon from "../../assets/images/rename-icon.png";
import downloadIcon from "../../assets/images/download-icon.png";
import deleteIcon from "../../assets/images/delete-icon.png";
import FolderDialog from "./FolderDialog";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_API_ENDPOINT } from "../../config/constant";
import { API_END_POINT } from "../../config/apiEndPoint";
import {
  downloadS3Folders,
  downloadFolder,
  editRepository,
  getRepository,
} from "../../redux/slices/apiSlice";
import { useDispatch } from "react-redux";
import moment from "moment";
import UseToast from "../../hooks/useToast";
import { getFileIcon, addFolderRoles } from "../../utils";
import Loader from "../../utils/Loader";
import FileListing from "./FileListing";
import CopyFolder from "./CopyFolder";
import CanAccess from "../../utils/CanAccess";
import { useSelector } from "react-redux";

import SearchBox from "../../components/common/SearchBox";
import uploadIcon from "../../assets/images/upload_icon.svg";
import breadcrumbArrow from "../../assets/images/breadcrumb_arrow.svg";
import folderIcon from "../../assets/images/folder_icon.svg";
import moreIcon from "../../assets/images/more_icon.svg";
import plusIcon from "../../assets/images/plus_icon.svg";
import fileImg from "../../assets/images/file_img.jpg";
import moreVertical from "../../assets/images/more_vertical.svg";
import infoIcon from "../../assets/images/info_icon.svg";
import editIcon from "../../assets/images/edit_icon.svg";
import copyIcon from "../../assets/images/copy_icon.svg";
import downloadBlack from "../../assets/images/download_black.svg";
import useAuth from "../../hooks/useAuth";
import BreadcrumbWithDropdown from "./BreadcrumbWithDropdown";
import Select from "react-select";


const DeleteFileContent = ({
  onClose,
  onButtonClick,
  openDeleteDialog,
  openDeleteDialogFile,
}) => {
  return (
    <div className="formBox">
      <div className="form-group">
        <label>{`Are you sure you want to delete this ${openDeleteDialogFile ? "file" : "folder"
          }?`}</label>
      </div>
      <div class="form-group !mb-0">
        <button class="blueBtn" onClick={onButtonClick}>
          Delete
        </button>
      </div>
    </div>
  );
};

const RenameFileContent = ({
  onClose,
  name,
  setName,
  onButtonClick,
  openRenameDialog,
}) => {
  useEffect(() => {
    openRenameDialog && setName("");
  }, [openRenameDialog]);

  return (
    <div className="formBox">
      <div className="form-group">
        <label>Rename</label>
        <input
          className="form-control"
          type="text"
          placeholder="Rename"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div class="form-group !mb-0">
        <button class="blueBtn" onClick={onButtonClick}>
          Rename
        </button>
      </div>
    </div>
  );
};

const FolderList = ({
  setOpenAddBtnDialog,
  setCurrentFolder,
  folderList,
  currentParentId,
  setCurrentParentId,
  resetFolders,
  fetchFolders,
  setRootParentObj,
  rootParentObj,
  isCommonFolder,
  setIsCommonFolder,
  isChildFolder,
  yearOptions
}) => {
  const [folders, setFolders] = useState([]);
  const [parentStack, setParentStack] = useState([]);
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openDeleteDialogFile, setOpenDeleteDialogFile] = useState(false);
  const [openRenameDialog, setOpenRenameDialog] = useState(false);
  const [name, setName] = useState("");
  const [clickedFolderId, setClickedFolderId] = useState(null);
  const [openCopyDialog, setOpenCopyDialog] = useState(false);
  const [openMoveDialog, setOpenMoveDialog] = useState(false);
  const token = sessionStorage.getItem("token");
  const menuRef = useRef(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [canAddChild, setCanAddChild] = useState(true);
  const { successToast, errorToast } = UseToast();
  const { isRepositoryLoading } = useSelector((state) => state.api);
  const [showBox, setShowBox] = useState(false);
  const boxRef = useRef(null);
  const { user } = useAuth();
  const [selectedYear, setSelectedYear] = useState(moment().year());
  const [isLandingPage, setIsLandingPage] = useState(false);
  const [filesList, setFilesList] = useState([]);

  
  // useEffect(() => {
  //   fetch(
  //     `http://localhost:3005/api/repository/getRepository?${
  //       currentParentId
  //         ? "&id=" + currentParentId
  //         : "user_id=660d6f5b4d1e1f3e3b47b8f1"
  //     }`
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.status && data.data.result) {
  //         setFolders(data.data.result);
  //       }
  //     })
  //     .catch((error) => console.error("Error fetching repositories:", error));
  // }, [currentParentId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setShowBox(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!folderList?.result || !folderList?.result.length) {
      setFolders([]);
    }
    // else if(!currentParentId){
    //   const agencyArr = [...new Map(folderList?.result.map(item => [item.agency, {...item, name: item.agency}])).values()];
    //   setFolders(agencyArr)
    // }
    else {
      setCanAddChild(
        !folderList.result.some((obj) => obj.folderType === "outlet") &&
        isChildFolder
      );
      setFolders(folderList.result);
    }

    if (
      folderList?.result?.length == 1 &&
      folderList?.result[0]?.folderType == "common_folder"
    )
      setIsCommonFolder(true);
  }, [folderList]);

  const handleFolderClick = (folder) => {
    setCurrentFolder(folder);
    setCanAddChild(!!folder.folderType && folder.folderType !== "outlet");
    ["head_office"].includes(folder.folderType) &&
      setRootParentObj({
        rootFolderId: folder._id,
        rootFolderType: folder.folderType,
      });
    folder.folderType == "common_folder"
      ? setIsCommonFolder(true)
      : setIsCommonFolder(false);
    const folderId = folder._id;
    const folderName = folder.name;
    setParentStack((prev) => [...prev, currentParentId]);
    setBreadcrumb((prev) => {
      const updatedBreadcrumb = [
        ...prev,
        { id: folderId, name: folderName, folderType: folder.folderType },
      ];
      return updatedBreadcrumb;
    });
    setCurrentParentId(null);
    if (folder.parent_id) {
      setCurrentParentId(folderId);
    } else {
      let agency = folderList?.result?.map((item) => item.agency);
      if (agency.includes(folder.name)) {
        setFolders(folderList?.result);
      } else {
        setCurrentParentId(folderId);
      }
    }
  };

  const handleRename = async () => {
    const headers = {
      Accept: "application/json",
      Authorization: token,
    };
    const payload = { name };
    try {
      let response = await dispatch(
        editRepository({ id: clickedFolderId, payload, headers })
      );
      setOpenRenameDialog(false);
      dispatch(
        getRepository({ payload: { id: currentParentId || "" }, headers })
      );
      setName("");
      successToast("Renamed successfully.");
    } catch (error) {
      console.error("Error renaming folder:", error);
      errorToast("Failed to rename folder.");
    }
  };

  const deleteFolder = async () => {
    try {
      setLoading(true);
      const response = await axios.delete(
        `${BASE_API_ENDPOINT}${API_END_POINT.deleteRepository}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: token,
          },
          params: {
            id: clickedFolderId,
          },
        }
      );
      fetchFolders(currentParentId);
      toast.success(response.data.message);
      setFolders(folders.filter((folder) => folder._id !== clickedFolderId));
      setOpenDeleteDialog(false);
      setOpenDeleteDialogFile(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);

      console.error("Error deleting repository:", error);
    }
  };

  const handleBack = () => {
    setCurrentParentId(parentStack[parentStack.length - 1] || null);
    setParentStack((prev) => prev.slice(0, -1));
  };

  const handleDownloadAction = async (folder) => {
    if (folder.type == "file" && folder.s3_file_name) {
      const filePath = folder.s3_file_name.split("/").slice(3).join("/");
      let fileData = await dispatch(downloadS3Folders({ filePath }));
      // let fileData = await dispatch(downloadFolder({ folderId: folder._id }));

      if (fileData?.payload) {
        try {
          const filename = filePath.split("/").pop();
          const url = window.URL.createObjectURL(fileData.payload);
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Error downloading file:", error);
        }

        //   try {
        //     const blob = new Blob([fileData?.payload], { type: "application/zip" });
        //     const url = window.URL.createObjectURL(blob);
        //     const a = document.createElement("a");
        //     a.href = url;
        //     a.download = "s3_folder.zip";
        //     document.body.appendChild(a);
        //     a.click();
        //     document.body.removeChild(a);
        //     window.URL.revokeObjectURL(url);
        // } catch (error) {
        //     console.error("Error downloading zip:", error);
        // }
        setOpenMenuId(false);
      } else {
        toast.error("Something went wrong in file download.");
        setOpenMenuId(false);
      }
    } else if (folder.type == "folder") {
      try {
        let fileData = await dispatch(downloadFolder({ folderId: folder._id }));
        if (fileData.payload instanceof Blob) {
          const url = window.URL.createObjectURL(fileData.payload);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${folder.name}.zip`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } else {
          console.error("Download failed: Response is not a Blob", fileData);
        }
        setOpenMenuId(false);

        // const blob = new Blob([fileData?.payload], { type: "application/zip" });
        // const url = window.URL.createObjectURL(blob);
        // const a = document.createElement("a");
        // a.href = url;
        // a.download = `${folder.name}.zip`;
        // document.body.appendChild(a);
        // a.click();
        // document.body.removeChild(a);
        // window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading zip:", error);
        toast.error("Something went wrong in folder download.");
        setOpenMenuId(false);
      }
    } else {
      toast.error("Something went wrong.");
    }
  };

  const getFoldersAtCurrentLevel = (folders, parentId) => {
    if (!folders.length) return [];
    if (parentId === null) {
      return folders;
    }
    const findChildren = (foldersList, targetId) => {
      for (const folder of foldersList) {
        if (folder._id === targetId) {
          return folder.children || [];
        }
        if (folder.children) {
          const result = findChildren(folder.children, targetId);
          if (result.length) return result;
        }
      }
      return [];
    };
    return findChildren(folders, parentId);
  };

  const displayedFolders = getFoldersAtCurrentLevel(folders, currentParentId);

  useEffect(() => {
    setIsLandingPage(displayedFolders.some(folder => folder.folderType === "root_folder"))
    setFilesList(displayedFolders.filter((folder) => folder.type === "file" && (folder.yearlyTags == selectedYear || (!folder.yearlyTags && folder.createdAt && moment(folder.createdAt).year() == selectedYear))));
  }, [displayedFolders]);



  const handleBreadcrumbClick = (folderId, index) => {
    setBreadcrumb((prev) => prev.slice(0, index + 1));
    setCurrentParentId(folderId);
  };
  const toggleMenu = (folderId) => {
    setOpenMenuId((prev) => (prev === folderId ? null : folderId));
  };
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenuId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <div className="overflow-scroll h-[69vh] scroll-smooth pb-20 w-full">
      {loading ? <Loader></Loader> : <></>}
      <BreadcrumbWithDropdown
        breadcrumb={breadcrumb}
        setCurrentFolder={setCurrentFolder}
        setCurrentParentId={setCurrentParentId}
        resetFolders={() => {
          setCurrentParentId(null);
          setBreadcrumb([]);
          resetFolders();
        }}
        folderlist={folderList}
        setIsCommonFolder={setIsCommonFolder}
        setBreadcrumb={setBreadcrumb} // Pass the setBreadcrumb function
      />

      {/* <div className="folderList grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4"> */}

      <div className="dashboard_card_wrap">
        {!canAddChild &&
          [...displayedFolders].filter((folder) => folder.type === "folder")
            ?.length == 0 && (
            <div className="dashboard_card_add">
              <img alt="" width="40px" height="33px" src={folderIcon} />
              <span>No child folders available.</span>
            </div>
          )}

        {[...displayedFolders]
          .filter((folder) => folder.type === "folder")
          ?.map((folder) => (
            <>
              <div key={folder._id} className="dashboard_card">
                <div
                  className="card_icon"
                  onClick={() => handleFolderClick(folder)}
                >
                  <img alt="" width="40px" height="33px" src={folderIcon} />
                </div>
                <div className="card_text">
                  <div>
                    <h6
                      className="inline-block cursor-pointer"
                      onClick={() => handleFolderClick(folder)}
                    >
                      {folder.name}
                    </h6>
                  </div>
                  <span>
                    {" "}
                    {folder.createdAt
                      ? moment(folder.createdAt).format("DD MMM YYYY")
                      : ""}
                  </span>
                  <button
                    type="button"
                    disabled={folder.type === "file"}
                    // onClick={() => setShowBox(true)}
                    onClick={() => toggleMenu(folder._id)}
                    className="more_btn"
                  >
                    <img alt="" width="24px" height="24px" src={moreIcon} />
                  </button>
                </div>

                {openMenuId === folder._id && (
                  <div ref={boxRef} className="filter_dropdown_box">
                    {/* <button className="filter_dropdown_btn" onClick={() => setOpenAddBtnDialog(true)}
                    >
                      <img
                        alt=""
                        width="16px"
                        height="16px"
                        src={editIcon}
                      />                   Add/Edit Tags

                    </button> */}
                    {/* <button className="filter_dropdown_btn"
                      onClick={() => {
                        setOpenRenameDialog(true);
                        setClickedFolderId(folder._id);
                      }}
                    >
                      <img
                        alt=""
                        width="16px"
                        height="16px"
                        src={editIcon}
                      /> Rename
                    </button> */}
                    {/* <button className="filter_dropdown_btn"
                      onClick={() => {
                        setOpenCopyDialog(true);
                        setClickedFolderId(folder._id);
                      }}
                    >
                      <img
                        alt=""
                        width="16px"
                        height="16px"
                        src={copyIcon}
                      /> Copy
                    </button>
                    <button className="filter_dropdown_btn"
                      onClick={() => {
                        setOpenMoveDialog(true);
                        setClickedFolderId(folder._id);
                      }}
                    >
                      <img
                        alt=""
                        width="16px"
                        height="16px"
                        src={downloadBlack}
                      /> Move
                    </button>
                    <button className="filter_dropdown_btn">
                      <img
                        alt=""
                        width="16px"
                        height="16px"
                        src={downloadBlack}
                      /> Share
                    </button> */}
                    <button
                      className="filter_dropdown_btn"
                      onClick={() => handleDownloadAction(folder)}
                    >
                      <img
                        alt=""
                        width="16px"
                        height="16px"
                        src={downloadBlack}
                      />{" "}
                      Download
                    </button>
                    {folder?.owner_id?._id == user?._id && (
                      <button
                        className="filter_dropdown_btn delete_btn"
                        onClick={() => {
                          setOpenDeleteDialog(true);
                          setOpenMenuId(null);
                          setClickedFolderId(folder._id);
                        }}
                      >
                        <img
                          alt=""
                          width="16px"
                          height="17px"
                          src={deleteIcon}
                        />{" "}
                        Delete
                      </button>
                    )}
                  </div>
                )}
              </div>
            </>
          ))}

        {/* Add Folder Button */}

        {currentParentId && canAddChild && (
          <CanAccess allowedRoles={[...addFolderRoles]}>
            <div
              className="dashboard_card_add"
              onClick={() => setOpenAddBtnDialog(true)}
            >
              <img alt="" width="40px" height="33px" src={plusIcon} />
              <span>Add Folder</span>
            </div>
          </CanAccess>
        )}

        {/* {currentParentId && canAddChild && (
          <CanAccess allowedRoles={[...addFolderRoles]}>
            <li
              class="addFolder min-h-[100px] cursor-pointer"
              onClick={() => setOpenAddBtnDialog(true)}
            >
              <label
                for="addFolder1"
                className="cursor-pointer"
                data-toggle="modal"
              >
                <span>
                  <img src={addIcon} alt="Folder" />
                </span>
                <span>Add Folder</span>
              </label>
            </li>
          </CanAccess>
        )} */}
      </div>

      {(displayedFolders?.length && !isLandingPage && !["Brand Creatives", "Repository, Approvals & Library"].includes(displayedFolders[0]?.parent_id?.name)) ? filesList.length ==  0 && (
          <div className="file_section_wrap">
            <div className="file_section_head   flex items-center justify-between">
              <h6>Files</h6>
              <div>
                <Select
                  options={yearOptions.map(year => ({
                    label: year,
                    value: year
                  }))}
                  value={{
                    label: selectedYear || moment().year(),
                    value: selectedYear || moment().year()
                  }}
                  className='customSelectBox1'
                  onChange={(obj) => { setSelectedYear(obj.value); }}
                  placeholder="Choose Year"
                />
              </div>
            </div>
            <div className="file_tab_content">
              <div className="tabs-content-card">
                <div className="content-card-title">
                  <div className="tooltip-wrapper">No files available.</div>
                </div>
              </div>
            </div>
          </div>
        ) : <></>}
      {(isLandingPage || filesList.length !== 0) && (
          <FileListing
            displayedFolders={filesList}
            isLandingPage={isLandingPage}
            fileImage={fileImage}
            getFileIcon={getFileIcon}
            setClickedFolderId={setClickedFolderId}
            setOpenRenameDialog={setOpenRenameDialog}
            setOpenDeleteDialogFile={setOpenDeleteDialogFile}
            handleDownloadAction={handleDownloadAction}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            yearOptions={yearOptions}
          />
        )}
      {(openDeleteDialog || openDeleteDialogFile) && (
        <FolderDialog
          isOpen={openDeleteDialog || openDeleteDialogFile}
          onClose={() => {
            setOpenDeleteDialogFile(false);
            setOpenDeleteDialog(false);
          }}
          title={`Delete ${openDeleteDialogFile ? "File" : "Folder"}`}
          content={
            <DeleteFileContent
              onClose={() => {
                setOpenDeleteDialogFile(false);
                setOpenDeleteDialog(false);
              }}
              onButtonClick={deleteFolder}
              openDeleteDialog={openDeleteDialog}
              openDeleteDialogFile={openDeleteDialogFile}
            />
          }
        />
      )}
      {openRenameDialog && (
        <FolderDialog
          isOpen={openRenameDialog}
          onClose={() => setOpenRenameDialog(false)}
          title="Rename Folder"
          content={
            <RenameFileContent
              onClose={() => setOpenRenameDialog(false)}
              name={name}
              setName={setName}
              onButtonClick={handleRename}
              openRenameDialog={openRenameDialog}
            />
          }
        />
      )}

      {openCopyDialog && (
        <FolderDialog
          isOpen={openCopyDialog}
          onClose={() => setOpenCopyDialog(false)}
          title="Copy"
          content={
            <CopyFolder
              onClose={() => setOpenCopyDialog(false)}
              openCopyDialog={openCopyDialog}
              displayedFolders={displayedFolders}
              handleFolderClick={handleFolderClick}
              mainParentId={currentParentId}
              toggleMenu={toggleMenu}
              copiedFolderId={clickedFolderId}
              rootParentObj={rootParentObj}
            />
          }
        />
      )}
      {openMoveDialog && (
        <FolderDialog
          isOpen={openMoveDialog}
          onClose={() => setOpenMoveDialog(false)}
          title="Move"
          content={
            <CopyFolder
              onClose={() => setOpenMoveDialog(false)}
              openMoveDialog={openMoveDialog}
              displayedFolders={displayedFolders}
              handleFolderClick={handleFolderClick}
              mainParentId={currentParentId}
              toggleMenu={toggleMenu}
              copiedFolderId={clickedFolderId}
              isMove={true}
              rootParentObj={rootParentObj}
            />
          }
        />
      )}
    </div>
  );
};

export default FolderList;
